/**
 * Agence'O - top-slider
 * @author Guillaume Bouillon (Agence'O)
 * @created 29/04/2019
 */

(function ($) {

  if ($('.top-slider__container').length) {
    // slider
    const topSlider = new Swiper('.top-slider__container', {
      slidesPerView: 'auto',
      slidesPerGroup: 2,
      spaceBetween: 30,
      centerInsufficientSlides: true,
      watchOverflow: true,
      touchEventsTarget: 'wrapper',
      wrapperClass: 'top-slider__wrapper',
      slideClass: 'top-slider__group',
      slideActiveClass: 'is-active',
      slideNextClass: 'is-next',
      pagination: {
        el: '.top-slider__pagination',
        type: 'bullets',
        clickable: true,
        bulletClass: 'top-slider__pagination__bullet',
        bulletActiveClass: 'is-active',
        lockClass: 'is-locked'
      },
      navigation: {
        nextEl: '.top-slider__btn--next',
        prevEl: '.top-slider__btn--prev',
        disabledClass: 'is-disabled',
        lockClass: 'is-locked'
      },
      breakpoints: {
        768: {
          slidesPerGroup: 1,
        },
        576: {
          slidesPerGroup: 1,
          spaceBetween: 10
        }
      }
    });
  }

}(jQuery));
